/**
 * The realtime channel grammar, copied from `service/src/channels.ts` (the contract with the subscribe
 * proxy and `app.can_subscribe`, 0040). `channels.test.ts` pins the exact strings on this side.
 */

/** A load's own stream (transitions and documents of that load). */
export function loadChannel(loadId: string): string {
  return `entity:load#${loadId}`;
}

/** A carrier's board (every load of that carrier). */
export function carrierChannel(carrierId: string): string {
  return `entity:carrier#${carrierId}`;
}

/** A user's direct stream (the rejection notice to the load's dispatcher). */
export function userChannel(userId: string): string {
  return `user:${userId}`;
}

/** A driver's chat thread (0093): the driver's app listens here; the office listens on its own user channel. */
export function chatChannel(threadId: string): string {
  return `entity:chat#${threadId}`;
}

/** loadboard-unified D3 (0359): a person's own load board stream. Presence on it means "this person has the
 *  board open" (the scheduler's gate for her Automatic searches); no history. */
export function boardChannel(userId: string): string {
  return `board:${userId}`;
}
